import { useEffect, useRef, useState } from "react";
import { api } from "./api";

const DEFAULT_CONFIG = {
  whatsapp_number: "",
  contact_phone: "",
  business_name: "Maa Vindhyavasini Packers Movers & Transport",
};

// Module-level cache shared across all useConfig callers.
let cachedConfig = null;

export function useConfig() {
  const [cfg, setCfg] = useState(cachedConfig);
  const didFetch = useRef(false);

  useEffect(() => {
    if (cachedConfig || didFetch.current) return;
    didFetch.current = true;
    api.get("/config")
      .then((r) => {
        cachedConfig = r.data;
        setCfg(cachedConfig);
      })
      .catch((err) => {
        console.error("Failed to load /api/config:", err);
      });
  }, []);

  return cfg || DEFAULT_CONFIG;
}

export function whatsappHref(number, text) {
  const num = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text || "Namaste, I want a shifting quote from Maa Vindhyavasini Packers Movers & Transport.")}`;
}

export function telHref(number) {
  return `tel:${(number || "").replace(/\s/g, "")}`;
}
